// AppLayout.jsx
import React from "react";
import {
  AppBar,
  Toolbar,
  Box,
  CssBaseline,
} from "@mui/material";
import { images } from "../../assets";

const AppLayout = ({ children }) => {
  return (
    <>
      <CssBaseline />
      <AppBar
        position="static"
        elevation={1}
        sx={{ backgroundColor: "#1976d2", color: "#fff", mb: 2 }}
      >
        <Toolbar sx={{ justifyContent: "center" }}>
          <img
            src={images.certageLogo}
            alt="Certage Logo"
            style={{
              height: "40px",
              width: "auto",
            }}
          />
        </Toolbar>
      </AppBar>
      {children}
      <Box
        component="footer"
        sx={{
          py: 2,
          backgroundColor: "#1976d2",
          color: "#fff",
          textAlign: "center",
          mt: 3,
          bottom: 0,
          width: "100%",
        }}
      >
        {/* Empty footer - only blue bar */}
      </Box>
    </>
  );
};

export default AppLayout;
